export default {
  title: 'Webhookin allekirjoitussalaisuus',
  warning:
    'Tallenna tämä salaisuus nyt – sitä ei näytetä enää uudelleen. Käytä sitä X-Webhook-Signature-otsikon varmentamiseen.',
  done: 'Valmis',
};
